import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from '@/contexts/AuthContext';
import { AuthGuardRoute } from '@/components/shared/AuthGuardRoute';
import { Layout } from '@/components/layout/Layout';
import Dashboard from '@/pages/Dashboard';
import Items from '@/pages/Items';
import Scenes from '@/pages/Scenes';
import Logs from '@/pages/Logs';
import Stats from '@/pages/Stats';
import Books from '@/pages/Books';
import Settings from '@/pages/Settings';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Admin from '@/pages/Admin';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/admin" element={<Admin />} />

            {/* Protected routes */}
            <Route element={<AuthGuardRoute />}>
              <Route element={<Layout />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/items" element={<Items />} />
                <Route path="/scenes" element={<Scenes />} />
                <Route path="/logs" element={<Logs />} />
                <Route path="/stats" element={<Stats />} />
                <Route path="/books" element={<Books />} />
                <Route path="/settings" element={<Settings />} />
              </Route>
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </QueryClientProvider>
  );
}
